import React from 'react';
import {View,Text,TouchableOpacity} from 'react-native';
import { Dimensions } from 'react-native';
import CurrencyInput from 'react-native-currency-input';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { MaterialIcons } from '@expo/vector-icons';
const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const valortroca=({navigation,route})=>{
  
const [value, setValue] = React.useState(0.00); 


return (
<SafeAreaProvider>
<View style={{maxWidth:windowWidth, backgroundColor:'#01150E',height:windowHeight,flex:1,alignItems:'center',justifyContent:'center'}}>
<MaterialIcons name="monetization-on" size={50} color="white" />
<View >
<Text style={{fontSize:40,color:'white'}}>Valor da troca</Text>
</View>
<View style={{alignItems:'center',borderBottomWidth:1,borderBottomColor:'white',margin:20}}>
<CurrencyInput
style={{color:'white',fontSize:25,textAlign:'center'}}
      value={value}
      onChangeValue={setValue}
      unit="$"
      delimiter=","
      separator="."
      precision={2}
      onChangeText={(formattedValue) => {
        console.log(formattedValue); // $2,310.46
      }}
    />
</View>
<TouchableOpacity onPress={()=>{
    if(value>0){
        navigation.navigate('Valor-Parcela',{valor:value,id:route.params.id,userid:route.params.userid});
    }
    
    }}>
<View style = {{backgroundColor: 'white', alignItems: 'center', 
justifyContent: 'center' ,borderRadius: 10,width:110 }}
>
<Text style = {{ color: '#01150E', padding:10}}>Continuar</Text>
</View>
</TouchableOpacity>
</View>
</SafeAreaProvider>);
}
export default valortroca;